<div class="container">
  <h2 mat-dialog-title>Edit Question</h2>

  <form [formGroup]="editForm" (ngSubmit)="onEditFormSubmit(editForm.value)">
    <mat-dialog-content>
      <div class="row">
        <mat-form-field appearance="fill">
          <mat-label>Type</mat-label>
          <mat-select formControlName="type" required>
            <mat-option value="text">Text</mat-option>
            <mat-option value="datetime">Datetime</mat-option>
            <mat-option value="boolean">Boolean</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field appearance="fill">
          <mat-label>Question</mat-label>
          <input matInput formControlName="question" required>
        </mat-form-field>
      </div>
    <div class="row" *ngIf="editForm.get('type').value === 'text' || editForm.get('type').value === 'datetime'">
      <mat-form-field appearance="fill">
        <mat-label>Required</mat-label>
        <mat-select formControlName="required" [value]="true">
          <mat-option [value]="true">Yes</mat-option>
          <mat-option [value]="false">No</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="row" *ngIf="editForm.get('type').value === 'boolean'">
      <mat-slide-toggle formControlName="acceptComment">
        Accept Comment
      </mat-slide-toggle>
    </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="close()">Cancel</button>
      <button mat-raised-button color="primary" type="submit">
        <span>Save</span>
      </button>
    </mat-dialog-actions>
  </form>
</div>